import Image from 'next/image';
import React, { memo } from 'react';

const CircledIcon = ({
  icon,
}: Readonly<{ icon: string; className?: string }>) => {
  return (
    <div
      className={
        'bg-back200 mb-2.5 flex size-[50px] items-center justify-center rounded-full'
      }
    >
      <Image src={icon} alt="circle-icon" width={32} height={32} />
    </div>
  );
};

export default memo(CircledIcon);
